// extracted by mini-css-extract-plugin
module.exports = {"root":"RecentlyViewed_root__jzIvP"};